<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title class="custom-title"> {{ 'enquetes' | nomenclatura | async }} </ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido"></div>
  <div class="gradient-extendido-div" *ngIf="enquete.id">
    <ion-grid>
      <ion-row class="ion-margin-top">
        <ion-col size="12">
          <i class="fas fa-clipboard-list div-icon"></i>

          <ion-label class="color-title"> {{ 'enquetes' | nomenclatura | async }} </ion-label>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-card>
      <div class="container">
        <img [src]="enquete.imagem | image:'enquete'" />
      </div>

      <ion-card-content>
        <p class="title ellipse two-lines">{{enquete.descricao}}</p>
        <p class="subtitle">{{enquete.observacao}}</p>

        <p class="subtitle">{{enquete.perguntas.length}} {{'Perguntas' | translate}}</p>

        <p class="resumo ellipse two-lines" *ngIf="enquete.isAnonimo == '1'">
          <i class="fas fa-user-lock"></i>
          {{'Resposta Anônima' | translate}}
        </p>

        <ion-row style="margin-left: -14px">
          <ion-col size="9">
            <ion-button
              class="btn-default btn-height"
              expand="block"
              [disabled]="disableBotao"
              (click)="iniciarEnquete()"
            >
              {{'Iniciar ' | translate}}{{'enquete' | nomenclatura | async}}
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-card-content>
    </ion-card>
  </div>
</ion-content>
